module.exports = __webpack_public_path__ + "fonts/roboto-v30-latin-300.b9c29351.woff2";